import { get, post, serialize } from '../httpClient';

export const transactionsAPI = {
  query: params => get('/api/transactions/query', params),
  createPayment: body => post('/api/transactions/create-payment', serialize(body)),
};
